import { useEffect, useState } from "react";
import { DialogBoxDatas } from "../../shared/interfaces/Common";
import './dialogbox.scss';
import { Card, CardHeader, CardContent, CardActions } from "../card/Card";
import { Label } from "../label/Label";
import { Button } from "../button/Button";

function DialogBox(props: { type: string, data: Partial<DialogBoxDatas>, isSubmitted: (value: boolean) => void }) {

    const [dialogBoxData, setDialogBoxData]: any = useState();

    const onClickSubmit = () => {
        props.isSubmitted(true)
    }

    const onClickCancel = () => {
        props.isSubmitted(false)
    }


    useEffect(() => {
        setDialogBoxData(props.data);
    }, [props.data]);

    return (
        <div className="notification-popup-wrap">
            <Card>
                <CardHeader className="pt-1 ps-4">
                    <Label className="neu-card-title sc-neu-card-title p-0 dialogHeader">{dialogBoxData?.title}</Label>
                </CardHeader>

                <CardContent className="px-4 dialogMessage">
                    <pre>
                        {dialogBoxData?.message}
                    </pre>
                </CardContent>
                <CardActions className="px-4 pb-4 text-end">
                    {props.type !== 'notification' && <Button color="blue" fillType="secondary" size="small" onClick={onClickCancel} className="dialogButton">Cancel</Button>}
                    <Button size="small" color="blue" fillType="primary" onClick={onClickSubmit} className="dialogButton">
                        <span>{dialogBoxData?.confirmButtonText?? 'Ok'}</span>
                    </Button>
                </CardActions>
            </Card>
        </div>
    )
}
export default DialogBox;